import { render, staticRenderFns } from "./Caratula.vue?vue&type=template&id=c0f10f7c&"
import script from "./Caratula.vue?vue&type=script&lang=js&"
export * from "./Caratula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports